import { inject, Injectable } from '@angular/core';
import { AccountService, FreightShipperService } from '@okcargo-apps/shared-application-ionic';
import { ECapabilities } from '@okcargo-apps/shared-domain-ionic';

@Injectable({
  providedIn: 'root',
})
export class RefreshDataService {
  private readonly freightShipService = inject(FreightShipperService);
  private readonly accountService = inject(AccountService);

  refreshAll(): void {
    this.accountService.hasCapability$(ECapabilities.UPLOAD_FREIGHTS).subscribe((hasCap) => {
      if (hasCap) {
        this.freightShipService.refreshFreightsShipNotFinished();
        this.freightShipService.refreshFreightsShipFinished();
      }
    });

    // TODO refresh company documents; refresh invoices

    // TODO refresh users/drivers; refresh vehicles
  }
}
